import { Component } from '@angular/core';

@Component({
    selector: '[cmpsEventCentreCardNameLabel]',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-event-centre-card-name-label',
    },
})
export class CardNameLabelComponent {}
